import { Navbar } from '@openx/components-core/lib/Navbar/Navbar';

import { Content } from './Content';
import { Layout } from './Layout';

export const Terms = () => (
  <Layout
    navbar={<Navbar helperMenuConfig={[]} userName="" showHelpIcon={false} showUserPanel={false} />}
    content={<Content />}
  />
);
